import React,{useEffect, useState} from 'react';
import "../../scss/surveyorMasterCreation.scss";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { editModeOn, firstLetterCapital, getFromDecreaptLocalStorage, selectedproductName, selectedVendorName } from '../../utilFunctions';
import Select from 'react-select';
import LoadingPage from '../../reusableComponents/loader/loadingPage';
import PdfViewer from '../../utilsComponent/PdfView';
import { DragDropFile } from '../dragAndDropComponent';
import { fetchDistricts, fetchMandals, fetchStates, fetchVillages, handleFileChange } from '../apiHelper';
import { createSurvyorMaster, defaultSurveryorFileData, getSurveyorData } from './helper';
import { getVendorsList } from '../vendorMaster/helper';
import DocumentPreviewModal from '../../utilsComponent/DocumentPreviewModal';
import AsteriskSymbol from '../../reusableComponents/AsteriskSymbol';
import { functionalities, PAGE_NAME_KEYS } from '../../consts';


const SurveyorMasterCreation = (props) => {
    const { roleDataCookie, productNames } = props
    const [surveyMasterShow, setSurveyMaster] = useState(false)
    const [statesList, setStatesList] = useState([])
    const [statesAllocationList, setStatesAllocationList] = useState([])
    const [districtList, setDistrictList] = useState([])
    const [districtAllocationList, setDistrictAllocationList] = useState([])
    const [mandalList, setMandalList] = useState([])
    const [mandalAllocationList, setMandalAllocationList] = useState([])
    const [villageList, setVillageList] = useState([])
    const [dragActive, setDragActive] = useState(false);
    const [isFileLoading, setIsFileLoading] = useState(false)
    const [vendorsList, setVendorsList] = useState([])
    const defaultcreateSurvyorData = {
        "relatedTo":"qc",
        "vendorId":"",
        "firstName":"",
        "lastName":"",
        "email":"",
        "mobileNumber":"",
        "aadhaarNumber":"",
        "panNumber":"",
        "state":"",
        "district":"",
        "mandal":"",
        "village":"",
        "status":"",
        "address":"",
        "panCard":defaultSurveryorFileData,
        "aadhaarCard":defaultSurveryorFileData,
        "isslaOrLicenseByIRDAI":defaultSurveryorFileData,
        "product":"",
        "stateForAllocationDetails":"",
        "districtForAllocationDetails":"",
        "tehsilOrMandal":""
    }
    const [createSurvyorData, setCreateSurvyorData] = useState(defaultcreateSurvyorData)
    const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList")
    const navigate = useNavigate();
    const requiredUploadDocumentsList = [
        {name: "PAN", id: `SurveyorsAndQc/${createSurvyorData.firstName}/panCard`, key: 'panCard', isRequired: false},
        {name: "Aadhaar", id: `SurveyorsAndQc/${createSurvyorData.firstName}/aadhaarCard`, key: 'aadhaarCard', isRequired: true},
        {name: "ISSLA/Licence by IRDAI", id: `SurveyorsAndQc/${createSurvyorData.firstName}/isslaOrLicenseByIRDAI`, key: 'isslaOrLicenseByIRDAI', isRequired: false},
    ]
    const [docUrls, setDocUrls] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [showFilePreview, setShowFilePreview] = useState(false);

    useEffect(() => {
        if(localStorage.getItem("SurveyorId")){
            getSurveyorData(getDistrictList, getDistrictAllocationList, getMandalList, getMandalAllocationList, getVillageList, setCreateSurvyorData, docUrls, requiredUploadDocumentsList, setDocUrls)
        } else if(!editModeOn(functionalities.SURVEYOR_MASTER_TAB)) {
            navigate(`/dashboard/${PAGE_NAME_KEYS.FORBIDDEN}`)
        }
    },[])


    useEffect(() => {
        getVendorsList(setVendorsList)
        getStatesList()
        // getStatesAllocationList()
    }, [])

    const getStatesList = async() => {
        const fetchedStates = await fetchStates();
        setStatesList(fetchedStates);
        setStatesAllocationList(fetchedStates);
    }

    const getDistrictList = async (state) => {
        if (state) {
            const fetchedDistricts = await fetchDistricts(state);
            setDistrictList(fetchedDistricts)
        }
    }

    const getDistrictAllocationList = async (state) => {
        if (state) {
            const fetchedDistricts = await fetchDistricts(state);
            setDistrictAllocationList(fetchedDistricts);
        }
    }

    const getMandalList = async(district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state)
            setMandalList(fetchedMandals)
        }
    }
    const getMandalAllocationList = async(district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state)
            setMandalAllocationList(fetchedMandals)
        }
    }
    
    const getVillageList = async(mandal, district, state) => {
         if (mandal && district && state) {
            const fetchedVillages = await fetchVillages(mandal, district, state);
            setVillageList(fetchedVillages);
        }
    }
    const handleDragEnter = () => {
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const fileData = event.dataTransfer.files[0];
        // file.push(fileData)
        // setFile([...file]);
    };

    const cancelCreateSurvyorMaster = () => {
        localStorage.removeItem("SurveyorId")
        setCreateSurvyorData(defaultcreateSurvyorData)
        navigate(`/dashboard/${PAGE_NAME_KEYS.SURVEYOR_MASTER}`)
    }

    const handleFilePreview = (fileUrl, fileType, fileName ) => {
        if (fileUrl && fileType && fileName) {
            setShowFilePreview(true)
            setSelectedFile({
                url: fileUrl,
                type: fileType.toLowerCase(),
                name: fileName
            })
        }
    }

    return (
        <>
            <section className="p-4">
                <h1 className="headerclaim">Surveyor Master Creation</h1>
                <hr className="upper_hr" />
                <div className="">
                    <h2 className="heading_h2Masters">Surveyor Master Creation</h2>
                    <div className="inner-boxSurveyCreationMasters">
                        <div className="container-fluid selectButtonsMasters">
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Related To<AsteriskSymbol/></label>
                                    <select name="selectMasters" className="selectMasters" value={createSurvyorData.relatedTo}  onChange={(e) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                relatedTo: e.target.value,
                                            })
                                        }}>
                                        <option value="" selected disabled hidden>Related to <span className="asteriskMasters"></span></option>
                                        <option value="Surveyor Vendor">Vendor Type - Surveyor Vendor</option>
                                        {/* <option value="individual">Vendor Type - Individual</option>
                                        <option value="qc">Vendor Type - QC</option> */}
                                    </select>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Vendor ID<AsteriskSymbol/></label>
                                    <Select id="exampleInputPassword1" options={vendorsList}
                                        classNamePrefix="bg-gray" placeholder="Select State"
                                        value={createSurvyorData.vendorId ? selectedVendorName(createSurvyorData.vendorId, vendorsList) : { label: "Select Vendor ID", value: "Select Vendor ID" }}
                                        onChange={(data) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                vendorId: data.value,
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">First Name<AsteriskSymbol/></label>
                                    <input type="text" id="first_name" placeholder="First Name" value={createSurvyorData.firstName} className="selectMasters" onChange={(e) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                firstName: e.target.value.replace(/[^a-zA-Z\s\W]/g, '').slice(0,30),
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Last Name<AsteriskSymbol/></label>
                                    <input type="text" id="last Name" placeholder="Last Name" className="selectMasters" value={createSurvyorData.lastName} onChange={(e) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                lastName: e.target.value.replace(/[^a-zA-Z\s\W]/g, '').slice(0, 30)
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Email</label>
                                    <input type="email" id="email" placeholder="Email" className="selectMasters" value={createSurvyorData.email} onChange={(e) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                email: e.target.value,
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Mobile Number<AsteriskSymbol/></label>
                                    <input type="tel" id="mob" placeholder="Mobile Number" className="selectMasters" maxlength="10" value={createSurvyorData.mobileNumber} onChange={(e) => {
                                          const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                          e.target.value = numericValue;
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                mobileNumber: e.target.value,
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Aadhaar Number<AsteriskSymbol/></label>
                                    <input type="tel" id="aadhaar" placeholder="Aadhaar Number" className="selectMasters" maxlength="12" value={createSurvyorData.aadhaarNumber} onChange={(e) => {
                                           const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                           e.target.value = numericValue;
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                aadhaarNumber: e.target.value,
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">PAN Number</label>
                                    <input type="text" id="pan" placeholder="Pan Number" className="selectMasters" maxLength="10" value={createSurvyorData.panNumber} onChange={(e) => {
                                             const alphabeticValue = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Convert to uppercase
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                panNumber: alphabeticValue.toLocaleUpperCase()  // Replace non-alphabetic characters with an empty string
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">State<AsteriskSymbol/></label>
                                    <Select id="exampleInputPassword1" options={statesList}
                                        classNamePrefix="bg-gray" placeholder="Select State"
                                        value={createSurvyorData.state ? { label: createSurvyorData.state, value: createSurvyorData.state } : { label: "Select State", value: "Select State" }}
                                        onChange={(data) => {
                                            getDistrictList(data.value)
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                state: data.value,
                                                district: "",
                                                mandal: "",
                                                village: ""
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword2">District<AsteriskSymbol/></label>
                                <Select id="exampleInputPassword2" options={districtList}
                                    classNamePrefix="bg-gray" placeholder="Select District"
                                    isDisabled={!createSurvyorData.state}
                                    value={createSurvyorData.district ? { label: createSurvyorData.district, value: createSurvyorData.district } : { label: "Select District", value: "Select District" }}
                                    onChange={(data) => {
                                        getMandalList(data.value, createSurvyorData.state)
                                        setCreateSurvyorData({
                                            ...createSurvyorData,
                                            district: data.value,
                                        })
                                    }}
                                />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword3">Mandal</label>
                                    <Select id="exampleInputPassword3" options={mandalList}
                                        classNamePrefix="bg-gray" placeholder="Select Mandal"
                                        isDisabled={!createSurvyorData.district}
                                        value={createSurvyorData.mandal ? { label: createSurvyorData.mandal, value: createSurvyorData.mandal } : ""}
                                        onChange={(data) => {
                                            getVillageList(data?.value || "", createSurvyorData.district, createSurvyorData.state)
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                mandal: data?.value || "",
                                                village: "",
                                            })
                                        }}
                                        isClearable = {true}
                                    />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <label for="exampleInputPassword1">Village</label>
                                    <Select id="exampleInputPassword1" options={villageList}
                                        classNamePrefix="bg-gray" placeholder="Select Village"
                                        isDisabled={!createSurvyorData.mandal}
                                        value={createSurvyorData.village ? { label: createSurvyorData.village, value: createSurvyorData.village } : ""}
                                        onChange={(data) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                village: data?.value || "",
                                            })
                                        }}
                                        isClearable = {true}
                                    />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                <label for="exampleInputPassword1">Address<AsteriskSymbol/></label>
                                    <input type="text" id="address" placeholder="Address" className="selectMasters-full" value={createSurvyorData.address} onChange={(e) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                address: e.target.value,
                                            })
                                        }} />
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4 mt-2">
                                <label for="exampleInputPassword2">Status<AsteriskSymbol/></label>
                                    <Select id="exampleInputPassword2" options={cmsStatusListCookies.map(list => {
                                        return { label: firstLetterCapital(list.name), value: list.id }
                                    })}
                                        classNamePrefix="bg-gray" placeholder="Select District"
                                        value={createSurvyorData?.status ? { label: createSurvyorData.status } : { label: "Select Status", value: "Select Status" }}
                                        onChange={(data) => {
                                            setCreateSurvyorData({
                                                ...createSurvyorData,
                                                status: data.label,
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                            {
                                requiredUploadDocumentsList.map(doc => (
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="align1_dataMasters survey_box1Masters">
                                            {
                                                !createSurvyorData[doc.key]?.docName && createSurvyorData[doc.key]?.isFileLoading ? (
                                                    <LoadingPage/>
                                                ) : (
                                                    createSurvyorData[doc.key]?.docName ? (
                                                        <>
                                                        {editModeOn(functionalities.SURVEYOR_MASTER_TAB) && (
                                                            <div className='d-flex justify-content-end'>
                                                            <i
                                                                className="fa fa-trash trash-icon m-2 pointer"
                                                                onClick={() => setCreateSurvyorData({ ...createSurvyorData, [doc.key]: defaultSurveryorFileData })}
                                                                title="delete"
                                                            ></i>
                                                            </div>
                                                        )}
                                                            <div onClick={() => {handleFilePreview(docUrls[doc.key], createSurvyorData[doc.key]?.fileType, doc.name)}}>
                                                                <div className='file-view' title='Click to view'>
                                                                    {createSurvyorData[doc.key]?.fileType?.toLowerCase() === "pdf" ? (
                                                                        docUrls[doc.key] && (
                                                                            <div className="pdf-viewer">
                                                                                <PdfViewer docUrl={docUrls[doc.key]} hidePlugins/>
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                            <img src={docUrls[doc.key]} title="Click to view" className="center-imgMasters image-original-size" alt = {`${doc.name}`}/>
                                                                        
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div
                                                                className="drop-zone"
                                                                onDragEnter={handleDragEnter}
                                                                onDragOver={handleDragOver}
                                                                onDragLeave={handleDragLeave}
                                                                onDrop={handleDrop}
                                                            >
                                                                <DragDropFile handleFileChange={(e) => handleFileChange(e, doc.id, doc.key, isFileLoading, setIsFileLoading, toast, roleDataCookie, createSurvyorData, setCreateSurvyorData, setDocUrls)} docId={doc.id} docKey={doc.key} disabled = {!editModeOn(functionalities.SURVEYOR_MASTER_TAB)}/>
                                                            </div>
                                                        </>
                                                    )
                                                )
                                            }
                                            <div className="img_descriptionMasters">
                                                {doc.name}
                                                {doc.isRequired && <AsteriskSymbol/>}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            </div>
                        </div>
                        <div className = "heading_detailsMasters">Allocation Details</div>
                <div className = "container-fluid selectButtonsMasters">
                    <div className = "row document-alignMasters">
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <label for="exampleInputPassword1">Product Name</label>
                            <Select id="exampleInputPassword1" options={productNames}
                                onInputChange={(inputValue) => {
                                    // Replace non-alphanumeric characters
                                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, '');
                                    return cleanedValue; // Return cleaned value for the Select component
                                }}
                                classNamePrefix="bg-gray" placeholder="Select Kshema Product"
                                value={createSurvyorData.product ? selectedproductName(createSurvyorData.product, productNames) : ""}
                                onChange={(data) => {
                                    // getCropsList(data.label); 
                                    setCreateSurvyorData({ ...createSurvyorData, 'product': data?.value || "" })
                                }}
                                isClearable = {true}
                            />
                        </div>
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label for="exampleInputPassword1">State<AsteriskSymbol/></label>
                                <Select id="exampleInputPassword1" options={statesAllocationList}
                                    classNamePrefix="bg-gray" placeholder="Select State"
                                    value={createSurvyorData.stateForAllocationDetails ? { label: createSurvyorData.stateForAllocationDetails, value: createSurvyorData.stateForAllocationDetails } : { label: "Select State", value: "Select State" }}
                                    onChange={(data) => {
                                        getDistrictAllocationList(data.value)
                                        setCreateSurvyorData({
                                            ...createSurvyorData,
                                            stateForAllocationDetails: data.value,
                                            districtForAllocationDetails: "",
                                            tehsilOrMandal: "",
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label for="exampleInputPassword2">District<AsteriskSymbol/></label>
                                <Select id="exampleInputPassword2" options={districtAllocationList}
                                    classNamePrefix="bg-gray" placeholder="Select District"
                                    isDisabled={!createSurvyorData.stateForAllocationDetails}
                                    value={createSurvyorData.districtForAllocationDetails ? { label: createSurvyorData.districtForAllocationDetails, value: createSurvyorData.districtForAllocationDetails } : { label: "Select District", value: "Select District" }}
                                    onChange={(data) => {
                                        getMandalAllocationList(data.value, createSurvyorData.stateForAllocationDetails)
                                        setCreateSurvyorData({
                                            ...createSurvyorData,
                                            districtForAllocationDetails: data.value,
                                            tehsilOrMandal: ""
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label for="exampleInputPassword3">Mandal</label>
                                <Select id="exampleInputPassword3" options={mandalAllocationList}
                                    classNamePrefix="bg-gray" placeholder="Select Mandal"
                                    isDisabled={!createSurvyorData.districtForAllocationDetails}
                                    value={createSurvyorData.tehsilOrMandal ? { label: createSurvyorData.tehsilOrMandal, value: createSurvyorData.tehsilOrMandal } : ""}
                                    onChange={(data) => {
                                        setCreateSurvyorData({
                                            ...createSurvyorData,
                                            tehsilOrMandal: data?.value || "",
                                        })
                                    }}
                                    isClearable = {true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className="backMasters" onClick={() => cancelCreateSurvyorMaster()}>Cancel</div>
                        {editModeOn(functionalities.SURVEYOR_MASTER_TAB) && (
                            <div className="submitMasters" onClick={() => createSurvyorMaster(createSurvyorData, toast, cancelCreateSurvyorMaster) }>Submit</div>
                        )}
                    </div>
                </div>
                    </div>
                </div>
            </section>

            {showFilePreview && selectedFile &&(
                <DocumentPreviewModal
                    fileType={selectedFile.type}
                    fileUrl={selectedFile.url}
                    heading={selectedFile.name}
                    onClose={()=>{
                        setShowFilePreview(false);
                        setSelectedFile(null)
                    }}
                    open={showFilePreview}
                />
            )}
        </>
    )
}

export default SurveyorMasterCreation
